<template>
  <div class="all">
    <div class="enterprisetop">
      <div style="float:left;height:100%;width:22%;border-right:1px solid #ccc;background: #F9FAFC;">
        <div class="companyid">
          {{dataForm.userId}}
        </div>
        <el-tooltip class="item"
                    effect="light"
                    content="个人账号"
                    placement="top">
          <div class="company">
            个人账号
          </div>
        </el-tooltip>
      </div>
      <div class="secondtable">
        <div>用户ID</div>
        <el-tooltip class="item"
                    effect="light"
                    :content="dataForm.custId"
                    placement="top">
          <div>{{ dataForm.custId }}</div>
        </el-tooltip>
        <div>姓名</div>
        <el-tooltip class="item"
                    effect="light"
                    :content="dataForm.name"
                    placement="top">
          <div>{{ dataForm.name }}</div>
        </el-tooltip>
        <div>注册来源</div>
        <el-tooltip class="item"
                    effect="light"
                    :content="dataForm.registChannel"
                    placement="top">
          <div>{{ dataForm.registChannel }}</div>
        </el-tooltip>
      </div>
      <div class="thirdtable">
        <div>最后一次访问时间</div>
        <el-tooltip class="item"
                    effect="light"
                    :content="dataForm.lastLogonTime"
                    placement="top">
          <div>{{ dataForm.lastLogonTime }}</div>
        </el-tooltip>
        <div>注册时间</div>
        <el-tooltip class="item"
                    effect="light"
                    :content="dataForm.registTime"
                    placement="top">
          <div>{{ dataForm.registTime }}</div>
        </el-tooltip>
        <div>注册端</div>
        <el-tooltip class="item"
                    effect="light"
                    :content="dataForm.registClient"
                    placement="top">
          <div>{{ dataForm.registClient }}</div>
        </el-tooltip>
      </div>
    </div>
    <div class="statistics">
      <div style="float:left">统计信息</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="statisticsTable"
              border
              style="width: 100%">
      <el-table-column prop="jine"
                       label="消费金额">
      </el-table-column>
      <el-table-column prop="shuliang"
                       label="订单数量">
      </el-table-column>
      <el-table-column prop="youhui"
                       label="优惠券（张）">
      </el-table-column>
      <el-table-column prop="yufu"
                       label="收藏商品">
      </el-table-column>
      <el-table-column prop="daifu"
                       label="收藏资料">
      </el-table-column>
      <el-table-column prop="xinyong"
                       label="已购课程">
      </el-table-column>
      <el-table-column prop="pingjia"
                       label="评价">
      </el-table-column>
      <el-table-column prop="guanlian"
                       label="登录次数">
      </el-table-column>
    </el-table>
    <div class="collections">
      <div style="float:left">收货地址</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="collectionsTable"
              border
              style="width: 100%">
      <el-table-column prop="zhangdan"
                       fixed
                       width="120"
                       label="姓名">
      </el-table-column>
      <el-table-column prop="leixing"
                       width="180"
                       label="手机号">
      </el-table-column>
      <el-table-column prop="riqi"
                       label="详细地址">
      </el-table-column>
      <el-table-column prop="yingfu"
                       width="120"
                       label="邮政编码">
      </el-table-column>
      <el-table-column prop="yishou"
                       label="默认地址"
                       width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.value"
                     active-color="#13ce66"
                     inactive-color="#ccc">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <div class="orderform">
      <div style="float:left">订单记录</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="orderformTable"
              border
              style="width: 100%">
      <el-table-column prop="bianhao"
                       fixed
                       label="订单编号">
      </el-table-column>
      <el-table-column prop="tijiao"
                       label="提交时间">
      </el-table-column>
      <el-table-column prop="zhanghao"
                       label="用户账号">
      </el-table-column>
      <el-table-column prop="jine"
                       label="订单金额">
      </el-table-column>
      <el-table-column prop="zhifu"
                       label="支付方式">
      </el-table-column>
      <el-table-column prop="laiyuan"
                       label="订单来源">
      </el-table-column>
      <el-table-column prop="zhuangtai"
                       label="订单状态">
      </el-table-column>
      <el-table-column prop=""
                       label="操作">
        <template>
          <div>查看订单</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        custId: 'CU20200923001', // 用户ID
        name: '王小二', // 姓名
        registChannel: '移动端，手机号注册（微信/QQ/OneLogin/Apple）', // 注册来源
        lastLogonTime: '2020-09-23 17:25:38', // 最后一次访问时间
        registTime: '2017-07-24 17:25:38', // 注册时间
        registClient: 'Android',
        userId: '18000000000'
      },
      // 统计信息
      statisticsTable: [
        {
          jine: 1000,
          shuliang: 100,
          youhui: 20,
          yufu: 30000,
          daifu: 70000,
          xinyong: '15',
          pingjia: '15',
          guanlian: 20
        }
      ],
      // 收款记录
      collectionsTable: [
        {
          zhangdan: '大梨',
          leixing: '180****1849',
          riqi: '广东省深圳市南山区科兴科学园',
          yingfu: '518000',
          yishou: '¥2500.00'
        },
        {
          zhangdan: '大梨',
          leixing: '180****1849',
          riqi: '广东省深圳市南山区科兴科学园',
          yingfu: '518000',
          yishou: '¥2500.00'
        },
        {
          zhangdan: '大梨',
          leixing: '180****1849',
          riqi: '广东省深圳市南山区科兴科学园',
          yingfu: '518000',
          yishou: '¥2500.00'
        },
        {
          zhangdan: '大梨',
          leixing: '180****1849',
          riqi: '广东省深圳市南山区科兴科学园',
          yingfu: '518000',
          yishou: '¥2500.00'
        }
      ],
      // 询价列表
      enquiryTable: [
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2019-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2018-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '支付宝', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥2000.00', // 订单金额
          zhifu: '微信', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        }
      ],
      // 订单列表
      orderformTable: [
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2019-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2018-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '支付宝', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥2000.00', // 订单金额
          zhifu: '微信', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        }
      ]
    }
  },
  methods: {
    init (val) {
    }
  },
  components: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped="scoped">
.enterprisetop {
  width: 100%;
  height: 121px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.companyid {
  height: 50px;
  width: 70%;
  text-align: center;
  line-height: 50px;
  margin-left: 15%;
  margin-top: 5px;
}
.company {
  height: 30px;
  width: 70%;
  text-align: center;
  line-height: 30px;
  margin-left: 15%;
  border: 1px solid red;
  background: red;
  color: white;
  border-radius: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  padding-right: 10px;
}
.allcompany {
  height: 140px;
  width: 100%;
  margin-top: 15px;
}
.allcompany div {
  width: 80%;
  margin-left: 10%;
  height: 20px;
  margin-top: 8px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
}
.secondtable,
.thirdtable {
  float: left;
  width: 39%;
  height: 100%;
}
.secondtable div:nth-of-type(odd) {
  width: 30%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: #f9fafc;
}
.secondtable div:nth-of-type(even) {
  width: 70%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding-left: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.thirdtable div:nth-of-type(odd) {
  width: 30%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: #f9fafc;
}
.thirdtable div:nth-of-type(even) {
  width: 70%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding-left: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
}
.statistics,
.collections,
.enquiry,
.orderform {
  width: 100%;
  height: 35px;
  line-height: 35px;
}
</style>
